import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { NotificationManager } from "../../../../../../../components/Notifications";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  deleteTemperatureList: []
};

const route = "modules/manage/modals/createEditManageTemperature/redux/slice";

export const manageDeleteManageTemperature = createAsyncThunk(
  "manage/deleteManageTemperature/deleteManageTemperature",
  async (payload, { rejectWithValue }) => {
    const mutations = [];
    try {
      const { items } = payload;
      if (items?.length) {
        items.forEach((item, key) => {
          item?.temperatureAlerts?.forEach((alert, index) => {
            mutations.push(`
                  alert${key}${index}: deleteSystemAlert(id: "${alert?.id}")
                `);
          });
        });
        const mutation = `mutation { ${mutations.join(" ")} }`;
        const response = await clientMutation(mutation, {}, endpoints.GRAPHQL_GENERAL);
        if (response?.alert00) return response.alert00;
        else throw "Error while deleting manage Temperatures";
      }
    } catch (exc) {
      NotificationManager.error(
        "Error",
        `Error Deleting Manage Temperature`,
        3000,
        null,
        null,
        "error"
      );
      ExceptionManager(exc, route, "deleteTemperature");
      rejectWithValue(exc);
    }
  }
);

const manageDeleteManageTemperatureRedux = createSlice({
  name: "manage/deleteManageTemperature",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
    },
    openModalDeleteManageTemperature(state, action) {
      state.open = true;
      state.deleteTemperatureList = action?.payload?.deleteTemperatureList;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    // manageDeleteManageTemperature
      builder.addCase(manageDeleteManageTemperature.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(manageDeleteManageTemperature.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
      builder.addCase(manageDeleteManageTemperature.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageDeleteManageTemperatureRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteManageTemperature } = actions;

// Export the reducer, either as a default or named export
export default reducer;
